module.exports = __webpack_public_path__ + "media/propaganda.d22429d3.mp4";